var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.061 32.561C22.768 32.854 22.384 33 22 33C21.616 33 21.232 32.854 20.939 32.561L15.939 27.561C15.353 26.975 15.353 26.026 15.939 25.44C16.525 24.854 17.474 24.854 18.06 25.44L21.999 29.379L42.051 9.328C41.207 7.373 39.261 6 37 6H12C8.968 6 6.5 8.468 6.5 11.5V36.5C6.5 39.532 8.968 42 12 42H37C40.032 42 42.5 39.532 42.5 36.5V13.121L23.061 32.561Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCheck);
export default __webpack_public_path__ + "static/media/white-check.8f80dc4bd14ba5d536443d472e46835a.svg";
export { ForwardRef as ReactComponent };